export default __webpack_public_path__ + "static/media/notesapp.cd07f9e3.png";